import {createAction} from "redux-actions";

export const requestNewData = createAction('FETCH_NEW_DATA');
export const receiveNewData = createAction('RECEIVE_NEW_DATA');
export const requestUser = createAction('FETCH_USER');
export const receiveUser = createAction('RECEIVE_USER');
export const receiveUserError = createAction('RECEIVE_USER_ERROR');
export const requestStyles = createAction('USER_FETCH_STYLES');
export const requestDifferentItems = createAction('USER_FETCH_DIFFERENT_ITEMS');
export const receiveStyles = createAction('USER_RECEIVE_STYLES');
export const requestSpecials = createAction('USER_FETCH_SPECIALS');
export const receiveSpecials = createAction('USER_RECEIVE_SPECIALS');
export const requestUsers = createAction('USER_FETCH_USERs');
export const receiveUsers = createAction('USER_RECEIVE_USERS');
export const requestShops = createAction('USER_FETCH_SHOPS');
export const receiveShops = createAction('USER_RECEIVE_SHOPS');
export const commonStateAction = createAction('COMMON_STATE_ACTION');
export const commonCityAction = createAction('COMMON_CITY_ACTION');
export const requestUserSave = createAction('REQUEST_USER_SAVE');
export const receiveUserSave = createAction('RECEIVE_USER_SAVE');
export const clearUserAction = createAction('CLEAR_USER_ACTION');
export const clearFollow = createAction('CLEAR_FOLLOW');
export const clearFollowItems = createAction('CLEAR_FOLLOW_ITEMS');
export const addCurrentUserAction = createAction('ADD_CURRENT_USER_ACTION');


// WEBPACK FOOTER //
// ./app/client/user/actions.ts